/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowList } from './ShowList';
import {
    ShowListFromJSON,
    ShowListFromJSONTyped,
    ShowListToJSON,
    ShowListToJSONTyped,
} from './ShowList';

/**
 * 
 * @export
 * @interface PaginatedShowListList
 */
export interface PaginatedShowListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedShowListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedShowListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedShowListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ShowList>}
     * @memberof PaginatedShowListList
     */
    results: Array<ShowList>;
}

/**
 * Check if a given object implements the PaginatedShowListList interface.
 */
export function instanceOfPaginatedShowListList(value: object): value is PaginatedShowListList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedShowListListFromJSON(json: any): PaginatedShowListList {
    return PaginatedShowListListFromJSONTyped(json, false);
}

export function PaginatedShowListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedShowListList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ShowListFromJSON)),
    };
}

  export function PaginatedShowListListToJSON(json: any): PaginatedShowListList {
      return PaginatedShowListListToJSONTyped(json, false);
  }

  export function PaginatedShowListListToJSONTyped(value?: PaginatedShowListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(ShowListToJSON)),
    };
}

